import Image from '@anm/components/image/Image';
import { getLinkTarget } from '@anm/helpers/upgradeLink';
import { FC } from 'react';
import styled from 'styled-components';

import routes from '../../../routes';

import { ItemTitleBlock } from './Wrapper';

const { Link } = routes;

export type LinkItemProps = { src: string; title: string; link: string; onClick: () => void };

const Wrapper = styled.div`
  padding: 10px;
  transition: background-color 100ms linear;
  border-radius: 10px;
  :hover {
    background-color: rgba(48, 174, 242, 0.1);
  }
`;

const LinkItem: FC<LinkItemProps> = ({ src, link, title, onClick }) => (
  <Wrapper onClick={onClick}>
    <Link route={link}>
      <a target={getLinkTarget("_blank")}>
        <Image width="320" src={src}></Image>
        <ItemTitleBlock direction="center" size="small" title={title} />
      </a>
    </Link>
  </Wrapper>
);

export default LinkItem;
